import type { BibleTranslations } from "../../src";

export const mockDataGetTrustedBibleTranslations: BibleTranslations = {
  translations: [
    {
      id: 1,
      name: "NRSV",
      description:
        "USCCB approved Catholic translation used in Hallow's Daily Mass Readings and various prayers on the app",
      language: "en",
      available: true,
      version: "2.1",
      url: "https://bible.hallow.app/translations/1.zip",
    },
    {
      id: 2,
      name: "NABRE",
      description:
        "USCCB approved Catholic translation used in the daily readings at Mass and Hallow's Daily Reflections & Daily Gospel",
      language: "en",
      available: true,
      version: "2.2",
      url: "https://bible.hallow.app/translations/2.zip",
    },
    {
      id: 3,
      name: "DHH",
      description:
        "La versión Dios Habla Hoy está aprobada por El Consejo Episcopal Latinoamericano (CELAM) y es una de las Biblias más utilizadas en América Latina.",
      language: "es",
      available: true,
      version: "2.1",
      url: "https://bible.hallow.app/translations/3.zip",
    },
    {
      id: 4,
      name: "Ave-Maria",
      description:
        "A Bíblia Ave-Maria é a primeira Bíblia católica publicada no Brasil. Com sua linguagem acessível, conquistou os lares brasileiros e, até hoje, é a Bíblia mais popular e querida entre os católicos do país.",
      language: "pt",
      available: true,
      version: "2.8",
      url: "https://bible.hallow.app/translations/4.zip",
    },
    {
      id: 5,
      name: "MBB",
      description:
        "Ang ginamit na salin ng Biblia ay ang Magandang Balita Biblia - Catholic Edition ©2012 ng Philippine Bible Society. Ito rin ang gamit ng Simbahang Katolika sa Pilipinas sa pagdiriwang ng liturhiya.",
      language: "tl",
      available: true,
      version: "2.1",
      url: "https://bible.hallow.app/translations/5.zip",
    },
    {
      id: 6,
      name: "GNB",
      description:
        "Die Gute Nachricht Bibel ist klar, verständlich und interkonfessionell erprobt. Bis heute gehört sie zu den einflussreichsten und am meisten verbreiteten modernen Bibelübersetzungen in deutscher Sprache.",
      language: "de",
      available: true,
      version: "2.1",
      url: "https://bible.hallow.app/translations/6.zip",
    },
    {
      id: 7,
      name: "ESP",
      description:
        "Teksty biblijne za: Pismo Święte Starego i Nowego Testamentu. Najnowszy przekład z języków oryginalnych z komentarzem. © Edycja Świętego Pawła, Częstochowa, PL, 2011. www.pismoswiete.pl Wykorzystano za zgodą właściciela praw.",
      language: "pl",
      available: true,
      version: "2.1",
      url: "https://bible.hallow.app/translations/7.zip",
    },
    {
      id: 8,
      name: "RSVCE",
      description:
        "USCCB approved Catholic translation widely used by many Catholics today ",
      language: "en",
      available: true,
      version: "2.2",
      url: "https://bible.hallow.app/translations/8.zip",
    },
    {
      id: 9,
      name: "PEV",
      description:
        "La Parola è Vita (Italian Contemporary New Testament) Copyright © 1981–1994 by Biblica, Inc.® Used by permission of Biblica, Inc.® All rights reserved worldwide.",
      language: "it",
      available: true,
      version: "2.4",
      url: "https://bible.hallow.app/translations/9.zip",
    },
    {
      id: 10,
      name: "HFA",
      description:
        "Hoffnung für alle® (Hope for all) Copyright © 1983, 1996, 2002, 2015 by Biblica, Inc.® Used by Permission of Biblica, Inc.® All rights reserved worldwide.",
      language: "de",
      available: true,
      version: "2.2",
      url: "https://bible.hallow.app/translations/10.zip",
    },
    {
      id: 11,
      name: "BDS",
      description:
        "La Bible du Semeur® Texte copyright © 1992, 1999, 2015 Biblica, Inc.® Utilisé avec la permission de Biblica, Inc.® Tous droits réservés.",
      language: "fr",
      available: true,
      version: "2.1",
      url: "https://bible.hallow.app/translations/11.zip",
    },
    {
      id: 14,
      name: "NFC",
      description:
        "Version de la Bible disponible dans toute la francophonie et interconfessionnelle, avec un langage accessible à tous, et souvent utilisée auprès d’un public jeune.",
      language: "fr",
      available: true,
      version: "1.2",
      url: "https://bible.hallow.app/translations/14.zip",
    },
    {
      id: 15,
      name: "PDV",
      description:
        "Bible reconnue par toutes les Églises, avec une traduction contemporaine, et rédigée dans un langage simple.",
      language: "fr",
      available: true,
      version: "1.2",
      url: "https://bible.hallow.app/translations/15.zip",
    },
  ],
  cookies: [
    {
      "CloudFront-Policy": "",
      "CloudFront-Key-Pair-Id": "",
      "CloudFront-Signature": "",
    },
  ],
};
